import md5 from 'md5';

export const getFileContentUrl = (file: GQL.IFile): string => {
  return `${process.env.REACT_APP_API_URL}/file-content/${file.id}/${md5(file.filename)}`;
};
